import React, { useEffect, useState } from 'react';
import { fetchGlobalLayout, fetchPageView } from '../../api/strapi';
import { useParams } from 'react-router-dom';
import {
    ContactUs,
    CurrentAndForecastAirQualityDisplays,
    DefaultPageTemplateImageAndTextBody,
    DefaultPageTemplateLeadershipBody,
    EventCalendar,
    ForecastAirQuality,
    HalfImageHalfText,
    News,
    Newsletter,
    PageHeader,
    PhotoGallery,
    Quote,
    ResourceLinks,
    ResourceMaterials,
    Resources,
    SingleVideoBand,
    Slideshow,
    SoftwareResources,
    Sponsors,
    TitleAndParagraph,
    VideoGallery,
} from '../bands';
import Footer from '../layout/Footer';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function PageView() {
    const { slug = '' } = useParams();
    const [globalLayout, setGlobalLayout] = useState([]);
    const [pageView, setPageView] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchGlobalLayout()
            .then(data => {
                setGlobalLayout(data);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
            });
        fetchPageView(slug)
            .then(data => {
                // Override default page title for non-home pages
                if (slug) {
                    document.title = data.title + " | Clean Air Partners";
                }
                setPageView(data);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    if (loading === true && Object.keys(globalLayout).length > 0 && Object.keys(pageView).length > 0) {
        setLoading(false);
    }

    if (loading) return <div></div>;
    if (error) return <div></div>;

    return (
        <div>
            <Header data={globalLayout.header} />

            <div className="main-container container-fluid">

                {pageView.headline ? <div className={"row headline-row vibrant-gradient parallax"}>
                                        <div className="section-headline white-text default-template-header-text">
                                            <p>{pageView.headline}</p>
                                        </div>
                                    </div>
                    : null}

                <div className="container-fluid no-padding default-template-container">

                    {/* Sidebar */}
                    {/* TODO: may need to be placed elsewhere here, or maybe even passed to a component directly? */}
                    {pageView.sidebar ? <Sidebar data={pageView.sidebar} /> : null}

                    {pageView.bands.map(band => (
                        <div key={band.__component + '.' + band.id} className="band" >
                            {/*style={{"borderBottom": "1px solid black"}} took the style out of the band cause it was messing things up*/}
                            {(() => {
                                // Contact Us Band
                                if (band.__component === 'bands.contact-us') {
                                    return (<ContactUs data={band.contact_us_band}/>);

                                // FIXME: CMS component "Current and Forecast Air Qaulity Displays" needs a typo fix for "quality"
                                // Current and Forecast Air Quality Displays Band
                                // } else if (band.__component === 'bands.current-and-forecast-air-quality-displays') {
                                    // return (<CurrentAndForecastAirQualityDisplays data={band.current_and_forecast_air_quality_displays_band}/>);
                                } else if (band.__component === 'bands.current-and-forecast-air-qaulity-displays') {
                                    return (<CurrentAndForecastAirQualityDisplays data={band.current_and_forecast_air_qaulity_displays_band}/>);

                                // Default Page Template Image and Text Body Band
                                } else if (band.__component === 'bands.default-page-template-image-and-text-body') {
                                    return (<DefaultPageTemplateImageAndTextBody data={band.default_page_template_image_and_text_body_band} slug={slug}/>);

                                // Default Page Template Leadership Body Band
                                } else if (band.__component === 'bands.default-page-template-leadership-body') {
                                    return (<DefaultPageTemplateLeadershipBody data={band.default_page_template_leadership_body_band}/>);

                                // Forecast Air Quality Band
                                } else if (band.__component === 'bands.forecast-air-quality') {
                                    return (<ForecastAirQuality data={band.forecast_air_quality_band} />);

                                // Half Image Half Text Band
                                } else if (band.__component === 'bands.half-image-half-text') {
                                    return (<HalfImageHalfText data={band.half_image_half_text_band} />);

                                // New Band
                                } else if (band.__component === 'bands.news') {
                                    return (<News data={band.news_band}/>);

                                // Newsletter Band
                                } else if (band.__component === 'bands.newsletter') {
                                    return (<Newsletter data={band.newsletter_band}/>);

                                // Page Header Band
                                } else if (band.__component === 'bands.page-header') {
                                    return (<PageHeader data={band.page_header_band} />);

                                // Photo Gallery Band
                                } else if (band.__component === 'bands.photo-gallery') {
                                    return (<PhotoGallery data={band.photo_gallery_band}/>);

                                // Quote Band
                                } else if (band.__component === 'bands.quote') {
                                    return (<Quote data={band.quote_band}/>);

                                // Resource Links Band
                                } else if (band.__component === 'bands.resource-links') {
                                    return (<ResourceLinks data={band.resource_links_band}/>);

                                // Resource Materials Band
                                } else if (band.__component === 'bands.resource-materials') {
                                    return (<ResourceMaterials data={band.resource_materials_band}/>);

                                // Resources Band
                                } else if (band.__component === 'bands.resources') {
                                    return (<Resources data={band.resources_band}/>);

                                // Slideshow Band
                                } else if (band.__component === 'bands.slideshow') {
                                    return (<Slideshow data={band.slideshow_block}/>);

                                // Software Resources Band
                                } else if (band.__component === 'bands.software-resources') {
                                    return (<SoftwareResources data={band.software_resources_band} slug={slug}/>);

                                // Sponsors Band
                                } else if (band.__component === 'bands.sponsors') {
                                    return (<Sponsors data={band.sponsors_band}/>);

                                // Title and Paragraph Band
                                } else if (band.__component === 'bands.title-and-paragraph') {
                                    return (<TitleAndParagraph data={band.title_and_paragraph_band} />);

                                // Video Gallery Band
                                } else if (band.__component === 'bands.video-gallery') {
                                    return (<VideoGallery data={band.video_gallery_band}/>);

                                // Event Calendar Band
                                } else if (band.__component === 'bands.event-calendar') {
                                    return (<EventCalendar data={band.event_calendar_band}/>);

                                } else if (band.__component === 'bands.single-video-band') {
                                    return (<SingleVideoBand data={band.single_video_item}/>);

                                }
                            })()}
                        </div>
                    ))}
                </div>
            </div>

            <Footer data={globalLayout.footer} />

        </div>
    );
}

export default PageView;
